import CircleInfoIconSvg from '@/assets/svgs/circle-info-outline.svg';
import CircleQuestionIconSvg from '@/assets/svgs/help-circle-outline.svg';
import classNames from 'classnames';
import { HTMLAttributes, ReactNode } from 'react';
import './styles.scss';

interface InputContainerProps extends HTMLAttributes<HTMLLabelElement> {
  labelClassName?: string;
  singleInputContainerClassName?: string;
  label: string;
  error?: string;
  isTouched?: boolean;
  hasMultipleInputs?: boolean;
  tooltipContent?: ReactNode;
  tooltipIcon?: 'info' | 'question';
  iconPrefix?: ReactNode;
  iconSuffix?: ReactNode;
  helperText?: string;
}

const InputContainer = ({
  className,
  labelClassName,
  singleInputContainerClassName,
  children,
  label,
  error,
  isTouched,
  hasMultipleInputs,
  tooltipContent,
  tooltipIcon = 'info',
  iconPrefix,
  iconSuffix,
  helperText,
}: InputContainerProps) => {
  // Tooltip rendering helper
  const renderTooltip = () => {
    if (!tooltipContent) return null;

    return (
      <span className="tooltip tooltip-top cursor-help" data-tip={tooltipContent}>
        {tooltipIcon === 'question' ? (
          <CircleQuestionIconSvg className="h-[14px] w-[14px] text-gray-400 transition-colors hover:text-gray-600" />
        ) : (
          <CircleInfoIconSvg className="h-[14px] w-[14px] text-gray-400 transition-colors hover:text-gray-600" />
        )}
      </span>
    );
  };

  return hasMultipleInputs ? (
    <div className={classNames('input-container form-control w-full', className)}>
      <div className={classNames('label flex !justify-start gap-1', labelClassName)}>
        <span className="label-text">{label}</span>
        {renderTooltip()}
      </div>
      {children}
      {helperText && (
        <div className="text-gray-default mt-2 px-1 text-[14px]">{helperText}</div>
      )}
      {error && isTouched && (
        <div className="label">
          <span className="text-error label-text-alt">{error}</span>
        </div>
      )}
    </div>
  ) : (
    <div className={singleInputContainerClassName}>
      <label className={classNames('input-container form-control w-full', className)}>
        <div className={classNames('label flex !justify-start gap-1', labelClassName)}>
          <span className="label-text">{label}</span>
          {renderTooltip()}
        </div>
        {iconPrefix}
        {children}
        {iconSuffix}
      </label>
      {helperText && (
        <div className="text-gray-default mt-2 px-1 text-[14px]">{helperText}</div>
      )}

      {error && isTouched && (
        <div className="label">
          <span className="text-error label-text-alt">{error}</span>
        </div>
      )}
    </div>
  );
};

export default InputContainer;
